export default __webpack_public_path__ + "static/media/home-corporate-img-02.d8fd9a3d.jpg";